import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import {
	Button,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	FormInput,
	FormMultiSelect,
	Loader,
	minWidth,
	Text,
	TextButton,
	units,
} from '@calm-web/design-system';

export const FormInputStyled = styled(FormInput).attrs({
	borderRadius: '100px',
	borderColor: 'gray3',
	iconColor: 'gray3',
})`
	max-width: ${units(86)};
`;

export const RegularText = styled(Text).attrs({
	size: FontSizes.base,
})``;

export const ClearLink = styled(TextButton)`
	color: ${palette('adaptiveText', 'white')};
	${fontSize(FontSizes.sm)};
	${fontWeight(FontWeights.Medium)};
	white-space: nowrap;
	margin-left: ${units(1)};
	text-decoration: none;
`;

export const SearchInputContainer = styled.div`
	display: flex;
	width: 100%;
`;

export const CategoryAndDurationContainer = styled.div<{ isInMsftMeeting?: boolean }>`
	${ifProp(
		'isInMsftMeeting',
		css`
			margin-bottom: ${units(2)};
		`,
		css`
			margin-bottom: ${units(5)};
		`,
	)};
	display: flex;
	gap: ${units(0.5)};
`;

export const SearchSubmitButton = styled(Button).attrs({
	type: 'submit',
	textColor: 'gray7',
	iconColor: 'iconColor',
})<{ isInMsftMeeting?: boolean }>`
	${ifProp(
		'isInMsftMeeting',
		css`
			border-color: ${palette('gray3')};
			margin-left: ${units(1)};
		`,
		css`
			margin-left: ${units(2)};
			width: ${units(17)};
		`,
	)};
`;

export const StyledFormMultiSelect = styled(FormMultiSelect).attrs({
	size: 'sm',
	tooltipTextSize: FontSizes.sm,
	borderColor: 'gray3',
	downArrowColor: 'gray3',
})``;

export const SearchContainer = styled.div<{ isInMsftMeeting?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: start;
	${SearchInputContainer} {
		margin-bottom: ${units(1.5)};
	}
	${SearchSubmitButton} {
		line-height: normal;
	}
	${minWidth('mobileSmall')} {
		${ifProp(
			'isInMsftMeeting',
			css`
				padding: 0 ${units(1)};
			`,
		)};
	}
`;

export const SearchStyledLoader = styled(Loader)`
	circle {
		fill: ${palette('adaptiveText', 'white')};
	}
`;

export const Form = styled.form`
	width: 100%;
`;
